module.exports = __webpack_public_path__ + "static/media/m13sj.de6d8683.png";